/**
 * @file navItems.js
 * @location src/data/navItems.js
 * @role 전역 nav 메타 — Topbar 링크 / 페이지 접근 가드(App.jsx) 공유.
 *
 * managerOnly: 매니저(isManager) 전용 페이지 (razor ⑳ — 직급별 navAccess 폐기, 매니저 축만).
 *   인원(members) 은 매니저 전용. 비매니저는 nav 에서 숨김 + 직접 진입 시 업무로 리다이렉트.
 */
export const NAV_ITEMS = [
  { key: 'tasks',   label: '업무', icon: 'todo' },
  { key: 'members', label: '멤버', icon: 'team', managerOnly: true },
];
